import React, { Component } from "react";
import i18n from "../../i18n";
import { Translation } from "react-i18next";
import "../../assets/css/help.scoped.css";
import NavBar from "../NavBar";
import FooterSmall from "../FooterSmall";

const SupportGoogleForm = "https://docs.google.com/forms/d/e/1FAIpQLScxZpR8Vz892hOZ_1R1HaO82LAp24sdcEWgoUzjYfO74DTfPQ/viewform?usp=header";
const faqPath01=  "https://docs.google.com/document/d/e/2PACX-1vRF7m7V1Yd8lSQ5X9he2nGiMhfRjOPcoq-hDa8oR0GY7daauMzCBFSOB3oclL4NmIVtyjgBl7RyvjaK/pub?embedded=true"  // "https://docs.google.com/forms/d/e/1FAIpQLScxZpR8Vz892hOZ_1R1HaO82LAp24sdcEWgoUzjYfO74DTfPQ/viewform?usp=header";

const faqPath02 = "https://docs.google.com/document/d/e/2PACX-1vRF7m7V1Yd8lSQ5X9he2nGiMhfRjOPcoq-hDa8oR0GY7daauMzCBFSOB3oclL4NmIVtyjgBl7RyvjaK/pub?embedded=true";
export class FAQEmbed02 extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <>
      <style>
        {`
        @media screen and (min-width: 1200px) {
          iframe.faqembed {
            min-height: 70vh;
            display: block;
            text-align: center;
            background-color: whitesmoke;
          }
        }
        `}
      </style>
      <NavBar />
      <div 
      //  className="support-form-embed-wrapper" 
       
       style={{ 
          //maxHeight: '80vh',
          overflowY: 'auto'
       }}>
        <div 
          style={{
              display: 'flex', 
              justifyContent: 'center',
              flexDirection:"column",
              
              }}>

        <iframe className="faqembed"
          src={faqPath02}
          width="100%" 
          height="100vh"
          style={{
            minHeight:"70vh",
            display:"block",
            //
            textAlign: "center",
            backgroundColor:"whitesmoke",
          }} 
          //
          margin="0 auto" 
          display="block"

          //</div></div>
          frameborder="0"

        >
        </iframe>
        
          {/* <iframe
            src={faqPath01}
            width="100%" 
            height="1285" 
            frameborder="0"
             margin="0 auto" 
             marginHeight="0"
             marginWidth="0"
             >
            Loading…</iframe> */}
        </div>
      </div>
        <div 
        style={{
          position: 'relative',
        }}
        >
        <FooterSmall />
        </div>
      </>
    )
  }
}

